import SuccessIcon from '@BUP/assets/Icons/success_alert_icon.svg'
import WarningIcon from '@BUP/assets/Icons/warning_alert_icon.svg'
import ErrorIcon from '@BUP/assets/Icons/error_alert_icon.svg'
import InfoIcon from '@BUP/assets/Icons/info_alert_icon.svg'

import PropTypes from 'prop-types'
import styles from './alert-component.module.scss'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

const AlertComponent = ({ message, messageKey, type, error, context }) => {
  const i18n = useTranslation()

  const classNameAlert = classNames(`${styles.container}`, {
    [styles.error]: type === 'error',
    [styles.info]: type === 'info',
    [styles.success]: type === 'success',
    [styles.warning]: type === 'warning'
  })

  if (error) {
    type = 'error'
    if (error.code) {
      message = i18n.t(messageKey, { context: error.code || context })
    } else {
      message = error.message
    }
  }

  let icon

  if (type === 'success') {
    icon = SuccessIcon
  } else if (type === 'warning') {
    icon = WarningIcon
  } else if (type === 'info') {
    icon = InfoIcon
  } else {
    icon = ErrorIcon
  }

  return (
    <div className={classNameAlert}>
      <div className={styles.icon_wrapper}>
        <img
          className={styles.icon}
          src={icon}
        />
      </div>
      <div className={styles.message_wrapper}>
        <span className={styles.text}>{message}</span>
      </div>
    </div>
  )
}

AlertComponent.propTypes = {
  message: PropTypes.string,
  type: PropTypes.string,
  error: PropTypes.any,
  context: PropTypes.string
}

AlertComponent.defaultProps = {
  type: 'success',
  error: null
}

export default AlertComponent
